import { useEffect, useState } from "react";
import axios from "axios";
import { TCalibration } from "./Calibration";

function useProjection(
  template: Array<Array<number>>,
  calibration?: TCalibration,
  baseUrl = "https://calibration.balljames.com"
) {
  const [data, setData] = useState<Array<[number, number]> | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const postdata = { calibration: calibration, world_template: template };
      try {
        setLoading(true);
        const response = await axios.post(baseUrl + "/projection", postdata, {
          headers: { "Content-Type": "application/json" },
        });
        setData(response.data);
      } catch (e) {
        setError(e);
      } finally {
        setLoading(false);
      }
    };
    if (calibration && template) {
      fetchData();
    }
  }, [baseUrl, calibration, template]);

  return { data, loading, error };
}

export default useProjection;
